export default "__VITE_ASSET__FAYHW8XW__"